export const peppolStatuses = {
  notRegistred: 'NOT_REGISTERED',
  registred: 'REGISTERED',
  kycSigned: 'KYC_SIGNED',
  activated: 'ACTIVATED',
};

export const cardPaymentCodes = ['54', '55'];
export const paymentFinancialAccountCodes = ['30'];
export const paymentMandateCodes = ['49'];

export const DocumentSource = {
  PEPPOL: 'PEPPOL',
};

export const B2C_ELECTRONIC_ADDRESS = '9999999999';

export const reportTypes = {
  DOCUMENT_REPORT: 'DOCUMENT_REPORT',
  VAT_REPORT: 'VAT_REPORT',
};
export const reportLabels = {
  DOCUMENT_REPORT: 'Document Report',
  VAT_REPORT: 'VAT Report',
};

export const X_MARMIN_OTP = 'X-MARMIN-OTP';

export const LANGUAGES = Object.freeze({
  EN: 'en',
  AR: 'ar',
  ZH: 'zh',
});

export const SITE_DIRECTIONS = Object.freeze({
  LTR: 'ltr',
  RTL: 'rtl',
});

export const LANGUAGE_CONFIG = Object.freeze({
  [LANGUAGES.EN]: Object.freeze({ dir: SITE_DIRECTIONS.LTR, dayjs: 'en', grid: 'enUS', htmlLang: 'en' }),
  [LANGUAGES.AR]: Object.freeze({ dir: SITE_DIRECTIONS.RTL, dayjs: 'ar', grid: 'arSD', htmlLang: 'ar' }),
  [LANGUAGES.ZH]: Object.freeze({ dir: SITE_DIRECTIONS.LTR, dayjs: 'zh-cn', grid: 'zhCN', htmlLang: 'zh-CN' }),
});

export const LANGUAGE_OPTIONS = Object.freeze([
  Object.freeze({ code: LANGUAGES.EN, codeLabel: 'EN', nativeLabel: 'English', englishLabel: 'English' }),
  Object.freeze({ code: LANGUAGES.AR, codeLabel: 'AR', nativeLabel: 'العربية', englishLabel: 'Arabic' }),
  Object.freeze({ code: LANGUAGES.ZH, codeLabel: 'ZH', nativeLabel: '中文', englishLabel: 'Chinese' }),
]);

export const DIRECTION_BY_LANGUAGE = Object.freeze({
  [LANGUAGES.EN]: LANGUAGE_CONFIG[LANGUAGES.EN].dir,
  [LANGUAGES.AR]: LANGUAGE_CONFIG[LANGUAGES.AR].dir,
  [LANGUAGES.ZH]: LANGUAGE_CONFIG[LANGUAGES.ZH].dir,
});

export const normalizeLanguage = (value) => (LANGUAGE_CONFIG[value] ? value : LANGUAGES.EN);

export const getLanguageConfig = (language) => LANGUAGE_CONFIG[normalizeLanguage(language)];
